/**
 *
 * Asynchronously loads the component for OpsMonitoringPage
 *
 */

import { lazyLoad } from "utils/loadable"

export const OpsMonitoringPage = lazyLoad(
  () => import("./index"),
  module => module.OpsMonitoringPage,
)
